import React, { FC } from 'react'
import { Field, InjectedFormProps, reduxForm } from 'redux-form'
import { Form, Collapse, Row, Col, Table } from 'antd'
import { v4 as uuidv4 } from 'uuid'
import { useTranslation } from 'react-i18next'
import { debounce } from 'lodash'
import { useSelector } from 'react-redux'
import { RootState } from '../../reducers'

// atoms
import ColorPickerField from '../../atoms/ColorPickerField'

// interfaces
import { IFormItemData } from '../../types/interfaces'

// utils
import { FORM, FORM_ATTRIBUTES, PROTECTION_INTERVAL_FOR_SAVING_ELEMENT } from '../../utils/enums'

// assets
import { ReactComponent as ChevronIcon } from '../../assets/icons/BaseIcons/chevron-down-1-icon.svg'

const { Panel } = Collapse

export type ComponentProps = {}

type Props = InjectedFormProps<IFormItemData, ComponentProps> &
	ComponentProps & {
		handleSubmit: Function
	}

const DocumentForm: FC<Props> = (props) => {
	const { t } = useTranslation()
	const { handleSubmit } = props
	const disabled = useSelector((state: RootState) => state.formTemplate.disable)
	const dataSource = useSelector((state: RootState) => state.formTemplate.formTableItems)

	const columns = [
		{
			title: `${t('loc:Label')}`,
			dataIndex: 'label',
			key: 'label'
		},
		{
			title: `${t('loc:Column in table')}`,
			dataIndex: 'tableColumn',
			key: 'tableColumn'
		}
	]

	const callButtonsColumns = [
		{
			title: `${t('loc:Label')}`,
			dataIndex: 'label',
			key: 'label'
		},
		{
			title: `${t('loc:Priority')}`,
			dataIndex: 'priority',
			key: 'priority'
		}
	]

	return (
		<Form layout={'vertical'} onSubmitCapture={handleSubmit}>
			<Row justify={'start'} className={'ml-2 w-full'}>
				<Col span={11} className={'h-34px flex flex-col'}>
					<p className={'m-0'}>{t('loc:Background color')}</p>
				</Col>
			</Row>
			<Row justify={'start'} className={'ml-2 mb-2 w-full'}>
				<Col className={'h-34px'} span={11}>
					<Field component={ColorPickerField} name={FORM_ATTRIBUTES.BACKGROUND} size={'medium'} disabled={disabled} />
				</Col>
			</Row>
			<Collapse expandIcon={({ isActive }) => <ChevronIcon rotate={isActive ? 0 : 180} />} expandIconPosition={'end'} defaultActiveKey={['1']} ghost>
				<Panel header={t('loc:Call buttons')} key={'1'}>
					<Table
						className={'document-table mb-2'}
						dataSource={dataSource.data?.callButtons || []}
						columns={callButtonsColumns}
						pagination={false}
						rowKey={() => uuidv4()}
						bordered={true}
						size={'small'}
						loading={dataSource.isLoading}
					/>
				</Panel>
			</Collapse>
			<Collapse expandIcon={({ isActive }) => <ChevronIcon rotate={isActive ? 0 : 180} />} expandIconPosition={'end'} defaultActiveKey={['1']} ghost>
				<Panel header={t('loc:Form elements')} key={'1'}>
					<Table
						className={'document-table mb-2'}
						dataSource={dataSource.data?.formElements || []}
						columns={columns}
						pagination={false}
						rowKey={() => uuidv4()}
						bordered={true}
						size={'small'}
						loading={dataSource.isLoading}
					/>
				</Panel>
			</Collapse>
		</Form>
	)
}

const form = reduxForm<IFormItemData, ComponentProps>({
	form: FORM.DOCUMENT_FORM,
	forceUnregisterOnUnmount: true,
	touchOnChange: true,
	destroyOnUnmount: true,
	onChange: debounce((values, dispatch, props) => {
		if (props.anyTouched) {
			props.submit()
		}
	}, PROTECTION_INTERVAL_FOR_SAVING_ELEMENT)
})(DocumentForm)

export default form
